import { useCallback, useRef } from 'react';

export function useDragScroll() {
  const ref = useRef(null);
  const state = useRef({ isDown: false, startX: 0, scrollLeft: 0 });

  const onMouseDown = useCallback((e) => {
    const el = ref.current;
    if (!el) return;
    state.current.isDown = true;
    state.current.startX = e.pageX - el.offsetLeft;
    state.current.scrollLeft = el.scrollLeft;
  }, []);

  const onMouseLeave = useCallback(() => {
    state.current.isDown = false;
  }, []);

  const onMouseUp = useCallback(() => {
    state.current.isDown = false;
  }, []);

  const onMouseMove = useCallback((e) => {
    if (!state.current.isDown) return;
    e.preventDefault();
    const el = ref.current;
    if (!el) return;
    const x = e.pageX - el.offsetLeft;
    el.scrollLeft = state.current.scrollLeft - (x - state.current.startX) * 2;
  }, []);

  const scrollByAmount = useCallback((amount) => {
    ref.current?.scrollBy({ left: amount, behavior: 'smooth' });
  }, []);

  return {
    ref,
    handlers: { onMouseDown, onMouseLeave, onMouseUp, onMouseMove },
    scrollByAmount,
  };
}
